/**
 * INTERNAL: this is the auth → user bridge.
 *
 * The ONLY allowed importer is `../model/auth.store.ts` (co-located in the
 * Same slice re-homed the auth store from `app/store/auth/`
 * to `entities/user/model/`). The bridge exists so that the auth lifecycle
 * can push the resolved signed-in user (or `null` on failure / sign-out)
 * into the canonical `entities/user` store WITHOUT exposing a write API to
 * the rest of the app.
 *
 * The single-writer invariant is what makes the dual-store pattern safe:
 * any layer can read via the selectors in `entities/user/api/user.selectors`,
 * but only the auth store ever mutates `useUserStore.user`. ESLint (see
 * `eslint.config.js`) forbids any other module from importing this path.
 *
 * Implementation note: we call `useUserStore.setState({ user })` directly
 * instead of capturing `useUserStore.getState().setUser`. This removes the
 * dependency on the store's action surface (which has no other callers) and
 * keeps the bridge's behavior visible at the call site.
 */
import { useUserStore } from '../model/user.store';

import type { AuthenticatedUser } from '../model/types';

export const setCurrentUser = (user: AuthenticatedUser | null) => useUserStore.setState({ user });
